export const seriesTypeOptions: SelectorOption<string>[] = [
  { label: "Standard", value: "standard" },
  { label: "Anime", value: "anime" },
  { label: "Daily", value: "daily" },
];
